export default "__VITE_ASSET__C_nGyo$f__"